<template>
    <div class="ebusy-wrapper" id="booking-wrapper">
        <div class="ebusy-container" id="container"></div>
    </div>
</template>
<script>
    export default {
        props: ['link'],
        mounted() {
            const script = document.createElement("script")
            script.onload = function () {
                let vm = this
                let c = document.getElementById('container')
                c.innerHTML = ''
                setTimeout(function()  {
                    // eslint-disable-next-line no-undef
                    ebusy.createBookingView('container', vm.link, {offset: '0',  url: 'ebusy.etc-ellerau.de'})
                },250)
            }.bind(this)
            script.src = "https://etc-ellerau-v8.ebusy.de/resources/js/ebusy.api.js";
            document.head.appendChild(script);
        }
    }
</script>
<style>
    .ebusy-container > iframe {
        border:0;
        height: 100%;
        width: 100%;
    }
    .ebusy-wrapper, .ebusy-container {
        height: 100%;
        width: 100%;
        border: 0;
    }
</style>
